<script setup>
import { computed } from "vue";
import {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
} from "@headlessui/vue";
import { ChevronDownIcon, CheckIcon } from "@heroicons/vue/20/solid";

const props = defineProps({
    options: Array,
    optionValueKey: {
        type: String,
        default: 'title',
    },
    requires: {
        type: String,
        default: 'false'
    },

    modelValue: [String, Number, Array],

    labelMain: String,

    placeholder: {
        type: String,
        default: "Select option",
    },
    multiple: Boolean,
    error: String
});

const emit = defineEmits(["update:modelValue"]);

const label = computed(() => {

    return props.options
        .filter(option => {

            if (Array.isArray(props.modelValue)) {
                return props.modelValue.find(item => item === option[props.optionValueKey]);
            }

            return props.modelValue === option[props.optionValueKey];
        })
        .map(option => option.title ?? option.label)
        .join(", ");
});

const href = computed(() => {

    return props.options
        .filter(option => {
            if (Array.isArray(props.modelValue)) {
                return props.modelValue.find(item => item === option[props.optionValueKey]);
            }
            return props.modelValue === option[props.optionValueKey];
        })
        .map(option => option.href ?? option.href)
        .join(", ");
});


</script>


<template>

    <Listbox as="div" :model-value="props.modelValue" :multiple="props.multiple"
        @update:modelValue="value => emit('update:modelValue', value)">
        <ListboxLabel v-if="labelMain" class="block text-sm font-medium text-gray-700 mt-6">{{ labelMain }} <span v-if="requires == 'True'" class="text-red-500 text-xs" > *</span></ListboxLabel>

        <div class="relative mt-1">
            <ListboxButton
                class="relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm">
                <span class="flex items-center">



                    <img v-if="href" :src="href" alt="" class="h-6 w-6 flex-shrink-0 rounded-full" />
                    <span v-if="label" class="ml-3 block truncate">{{ label }}</span>
                    <span v-else class="ml-3 text-gray-500">{{ props.placeholder }}</span>
                </span>
                <span class="pointer-events-none font-bold absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                    <ChevronDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                </span>

            </ListboxButton>

            <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                leave-to-class="opacity-0">

                <ListboxOptions
                    class="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                    <ListboxOption v-for="option in props.options" :key="option.id" v-slot="{ active, selected }"
                        :value="option[props.optionValueKey]" as="template">





                        <li
                            :class="[active ? 'text-white bg-blue-600' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9']">
                            <div class="flex items-center">
                                <img v-if="option.href" :src="option.href" alt=""
                                    class="h-6 w-6 flex-shrink-0 rounded-full border-gray-300 border" />
                                <span :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">{{
                                        option.title
                                }}</span>
                            </div>

                            <span v-if="selected"
                                :class="[active ? 'text-white' : 'text-blue-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                                <CheckIcon class="h-5 w-5" aria-hidden="true" />
                            </span>
                        </li>





                    </ListboxOption>
                </ListboxOptions>
            </transition>
        </div>
    </Listbox>


</template>